// 测试环境
// let proxyUrl = 'http://traffic.xzkaishang.com/api';//域名
// const imgUrl = 'http://traffic.xzkaishang.com';//静态路径

// 正式环境
let proxyUrl = 'https://www.xzjtkg.com/api';//域名
const imgUrl = 'https://www.xzjtkg.com/';//静态路径
export {
    proxyUrl,
    imgUrl
}